import { StyledParagraph } from "./detailsBtn.styles";
import { useNavigate } from "react-router-dom";
import { t } from '@app/utils/translation'
import { useSelector } from "react-redux";
import { RootState } from "@app/store";

type DetailsBtnProps = {};

export const DetailsButton = ({  }: DetailsBtnProps) => {

  let navigate = useNavigate();
  const language  = useSelector((state: RootState) => state.setting.language );
  const primaryColor  = useSelector((state: RootState) => state.setting.colors.primary );
  const trackOrderCode  = useSelector((state: RootState) => state.order.trackOrderCode );
  const isDropoffTracking = useSelector((state: RootState) => state.order.isDropoffTracking);


  async function goToDetails() {
    navigate(isDropoffTracking ? `/d/details/${trackOrderCode}` : `/details/${trackOrderCode}`);
  }

  return (
    <StyledParagraph onClick={goToDetails} color={primaryColor} >
      {t('OrderDetails',language)}
    </StyledParagraph>
  );
};
